module.exports = __webpack_public_path__ + "static/media/recpie2.e0e03962.png";